import { render, staticRenderFns } from "./BabakJunior2.vue?vue&type=template&id=e8e61a16&scoped=true"
import script from "./BabakJunior2.vue?vue&type=script&lang=js"
export * from "./BabakJunior2.vue?vue&type=script&lang=js"
import style0 from "./BabakJunior2.vue?vue&type=style&index=0&id=e8e61a16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e61a16",
  null
  
)

export default component.exports